import { render, staticRenderFns } from "./media-image.vue?vue&type=template&id=e663501e&scoped=true&"
import script from "./media-image.vue?vue&type=script&lang=js&"
export * from "./media-image.vue?vue&type=script&lang=js&"
import style0 from "./media-image.vue?vue&type=style&index=0&id=e663501e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e663501e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VImg,VSheet,VSkeletonLoader})
